module.exports = "<div class=menu transition=menu-side> <a @click=onNavClick(null) class=menu-all>全部 <span class=all-span></span></a> <ul class=menu-list> <li v-for=\"item in menuList\"> <a :class=\"{'active' : cateid == item.cateid }\" @click=onNavClick(item.cateid)> <span class=menu-keyword>{{item.cateName}}</span> <span class=menu-keyinfo>{{item.subName}}</span> </a> </li> </ul> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Menu/Menu.vue
 ** module id = 313
 ** module chunks = 4
 **/